import {IPreviewTextVariant} from "../interfaces/preview-text-variant.interface";

export const clinicPreviewTexts: IPreviewTextVariant = {
    sidebar_athletes: 'Patients',
    sidebar_athletes_link: 'patients',
    athletes_title: 'Patients',
    create_athlete_button_label: "Create patient",
    reached_athletes_limit: 'You have reached the limit of patients.',
    save_athlete_link: '/save-patient',
    remove_selected_athletes: "Remove selected patients",
    no_athletes: "No patients",
    no_athletes_description: "There are no patients that match the\n" +
        "              selected filters. Select other filters or press the button on the\n" +
        "              right to create a new one.",
    athletes_page_link: '/patients',
    most_active_athletes: 'Most active patients',
    sidebar_workouts: 'Protocols',
    sidebar_workouts_link: '/protocols',
    create_workout_link: '/protocols/create',
    workouts_title: "Protocols",
    deleted_workouts: "Deleted protocols",
    push_workouts_to_locaitons: "Push protocols to locations",
    this_workout_is_empty: "This protocol is empty",
    restore_deleted_workouts: "Restore deleted protocols",
    go_to_workouts: "Go to protocols",
    no_deleted_workouts: "There are no deleted protocols.",
    create_workout_title: "Create protocol",
    add_new_playlist_to_workout: "Add a new playlist in this protocol",
    edit_workout_title: "Edit protocol",
    push_workouts_success: "The protocols have been succesfully pushed to the locations!",
    push_workouts_error: "There was an error pushing the protocols to the location.",
    workout_created_success: "Protocol created succesfully!",
    workout_edited_success: "Protocol edited succesfully!",
    get_workout_error: "There was an error fetching the protocol.",
    delete_workout_confirm_text:  "Are you sure you want to delete this protocol?",
    athlete_updated_success: "Patient updated succesfully!",
    athlete_created_success: "Patient created succesfully!",
    atheletes_bulk_import_error: "There was an error on patients bulk import.",
    most_active_exercise_athelete_name: "Patient name",
    athlete_bulk_import_template: "PATIENTS_BULK_IMPORT_TEMPLATE",
    remaining_athletes: "remaining_patients",
    restore_workout_confirm_text: "Are you sure you want to restore this protocol?",
    workout_title: 'Protocol'
}

